import { render, staticRenderFns } from "./EducationalGroupAttendanceFormUpdate.vue?vue&type=template&id=11b38686&"
import script from "./EducationalGroupAttendanceFormUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendanceFormUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports